import DayJsAdapter from '@date-io/dayjs'
import { Capacitor } from '@capacitor/core'
import '@fortawesome/fontawesome-pro/css/all.css'
import { de as dateDe } from 'date-fns/locale'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { getIconsFlattened } from 'plugins/i18n/icons.ts'
import { createVuetify } from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { aliases, fa } from 'vuetify/iconsets/fa'
import { md } from 'vuetify/iconsets/md'
import { VIconBtn } from 'vuetify/labs/VIconBtn'
import { de, en } from 'vuetify/locale'
import domainGet from '@/helpers/domainGet'
import { fontawesomeAliases } from './aliases'
import { brandTheme, brandVariantColors, isHausperfektDomain } from './themes'

// Dieselbe Quelle wie der Client-Store (backend.url.domain, ermittelt per
// domainGet), sonst blitzt bei Hosts wie hausperfekt-kunde.aaremo.de kurz die
// falsche Palette auf. Capacitor und ungueltige Hosts: wie dort Aaremo.
const initialIsHpDomain = () => {
	if (Capacitor.getPlatform() !== 'web') return false
	try {
		return isHausperfektDomain(domainGet()?.domain)
	} catch {
		return false
	}
}

// Add the UTC plugin to dayjs
dayjs.extend(utc)

const createVuetifyWithOptions = () => {
	const isHpDomain = initialIsHpDomain()
	return createVuetify({
		components: {
			VIconBtn,
		},
		defaults: {
			VTextField: {
				variant: 'underlined',
			},
			VCombobox: {
				variant: 'underlined',
			},
			VAutocomplete: {
				variant: 'underlined',
				color: 'primary',
			},
			VSelect: {
				variant: 'underlined',
			},
			VIcon: {
				size: 'small',
			},
			// Vuetifys Standardvariante ist `elevated` und bringt einen
			// Dropshadow mit, was der Flat-Design-Vorgabe widerspricht. `flat`
			// ist dieselbe Variante ohne Schatten — Farbe und Groesse bleiben.
			// Als Default statt als CSS-Override, damit es auch in Dialogen und
			// Menues greift; ein explizites variant="elevated" an einer Stelle
			// sticht das weiterhin.
			VBtn: {
				variant: 'flat',
			},
			// Frueher hellte dieser Default verschachtelte Karten stufenweise auf
			// (bg-surface-lighten-1 / -2), um sie voneinander abzusetzen. Im
			// hellen Theme faellt das kaum auf — surface ist bereits weiss —,
			// im dunklen wurde aus jeder inneren Karte ein sichtbar hellerer
			// Kasten (rgb(54,54,54) auf rgb(33,33,33)). Ohne die Abstufung
			// liegen innere Karten auf derselben Flaeche wie ihr Container und
			// fuegen sich in beiden Themes ein; abgegrenzt wird ueber Abstand
			// und Trennlinien statt ueber Helligkeitsstufen.
		},
		icons: {
			defaultSet: 'fa',
			aliases: {
				...aliases,
				...fontawesomeAliases,
				...getIconsFlattened(),
			},
			sets: {
				md,
				fa,
			},
		},
		locale: {
			locale: 'de',
			fallback: 'en',
			messages: { de, en },
		},
		date: {
			adapter: DayJsAdapter,
			locale: {
				de: dateDe,
			},
		},
		theme: {
			defaultTheme: 'client',
			variations: {
				colors: [
					'nav',
					'table',
					'background',
					'surface',
					'error',
					'success',
					'info',
				],
				lighten: 2,
				darken: 2,
			},
			themes: {
				client: {
					// Bis die Mandanteneinstellungen geladen sind (und falls das
					// scheitert) gilt die Palette der Marke, nicht pauschal HausPerfekt.
					...brandTheme(isHpDomain),
				},
				dark: {
					dark: true,
					colors: {
						...brandVariantColors(isHpDomain, 'dark'),
						nav: '#121212',
						text: '#ff1493', // TODO: TEST FARBE IF SEEN ACT!!
						//table: '#0b0b0b',
						table: '#121212',
					},
				},
				light: {
					dark: false,
					colors: {
						...brandVariantColors(isHpDomain, 'light'),
						nav: '#ffffff',
						text: '#ff1493', // TODO: TEST FARBE IF SEEN ACT!!
						//	table: '#f0f0f0',
						table: '#ffffff',
					},
				},
			},
		},
	})
}

export async function createVuetifyInstance() {
	return createVuetifyWithOptions()
}
